var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTeleError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66406 0.450195C8.94348 0.450219 9.21828 0.525079 9.45898 0.666992C9.69951 0.808905 9.89799 1.01248 10.0332 1.25684V1.25781L16.6807 13.2256C16.813 13.4639 16.8815 13.7332 16.8779 14.0059C16.8744 14.2784 16.7996 14.5455 16.6611 14.7803C16.5226 15.0151 16.3248 15.2097 16.0879 15.3447C15.8511 15.4797 15.5831 15.5503 15.3105 15.5498H2.01367C1.74145 15.5497 1.47361 15.4789 1.2373 15.3438C1.00105 15.2086 0.804101 15.0139 0.666016 14.7793C0.527889 14.5445 0.453583 14.2772 0.450195 14.0049C0.446819 13.7325 0.514251 13.4637 0.646484 13.2256L7.29492 1.25781V1.25684C7.43017 1.01246 7.62856 0.808888 7.86914 0.666992C8.10988 0.525057 8.38459 0.450195 8.66406 0.450195Z",
    stroke: "#FF0700",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTeleError);
export default __webpack_public_path__ + "static/media/ic_tele_error.653e85e6829fc4821ff88685773a788d.svg";
export { ForwardRef as ReactComponent };